<template>
  <div class="container">
    <div class="top-wrapper">
      <div class="nav-item" id="right-nav-item">
        <img src="../../../assets/image/m-tz.png" class="nav-icon" @click="goNews()" />
        <!-- <img src="../../../assets/image/switch.png" class="nav-icon" style="margin-right: 0"
          @click="$router.push('/member/sign_out')" /> -->
      </div>
      <div class="top-info-wrapper">
        <div class="avatar-wrapper">
          <img class="avatar" :src="user.member_avatar" @click="triggerFileSelect"/>
          <span><svg t="1737822916407" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4187" width="20" height="20"><path d="M684.202667 117.248c15.893333-15.872 42.154667-15.36 58.922666 1.408l90.517334 90.517333c16.661333 16.661333 17.344 42.986667 1.429333 58.922667l-445.653333 445.653333c-7.936 7.914667-23.104 16.746667-34.218667 19.776l-143.701333 39.253334c-21.909333 5.994667-35.114667-7.104-29.568-28.949334l37.248-146.773333c2.773333-10.944 11.562667-26.346667 19.392-34.176l445.653333-445.653333zM268.736 593.066667c-2.901333 2.901333-8.106667 12.074667-9.130667 16.021333l-29.12 114.773333 111.957334-30.570666c4.437333-1.216 13.632-6.549333 16.810666-9.728l445.653334-445.653334-90.517334-90.496-445.653333 445.653334zM682.794667 178.986667l90.517333 90.517333-30.186667 30.186667-90.496-90.517334 30.165334-30.165333z m-362.026667 362.048l90.496 90.517333-30.165333 30.165333-90.517334-90.496 30.165334-30.186666zM170.666667 874.666667c0-11.776 9.429333-21.333333 21.461333-21.333334h661.077333a21.333333 21.333333 0 1 1 0 42.666667H192.128A21.333333 21.333333 0 0 1 170.666667 874.666667z" fill="#ef4719" p-id="4188" data-spm-anchor-id="a313x.search_index.0.i0.ff143a811vuNTf" class=""></path></svg></span>
          <input type="file" ref="fileInput" @change="onMemberAvatar" accept="image/*" style="display: none;" />
        </div>
        <div class="nickname">
          <p>{{ user.member_name }}</p>
          <span class="addtime">{{ user.member_addtime }}</span>
        </div>
      </div>
      <div class="info-wrapper">
        <div class="info-item" @click="goAccount">
          <div class="item price">${{ getAvailablePredeposit }}</div>
          <div class="item">USDT</div>
        </div>
        <div class="info-item" @click="goCommission(0)">
          <div class="item price">$ {{ user.share_price }}</div>
          <div class="item">{{ $t("Direct") }}</div>
        </div>
        <div class="info-item" @click="goCommission(1)">
          <div class="item price">$ {{ user.parent_share_price }}</div>
          <div class="item">{{ $t("Indirect") }}</div>
        </div>
        <!-- <div class="info-item" @click="goScoreList">
          <div class="item price">{{ getScore }}</div>
          <div class="item">{{ $t("points") }}</div>
        </div> -->
      </div>
    </div>

    <div class="banner-container">
        <div class="slick-slider" ref="slick">
          <div>
            <img src="../../../assets/image/im.png" @click="gotoIm" alt="gotoIm"/>
          </div>
          <div>
            <img src="../../../assets/image/home/gobuy.png" @click="gotobuy" alt="gobuy"/>
          </div>
        </div>
    </div>
    <div class="tools order">
      <div class="manage-wrapper">
        <div class="manage_box1">
          <!-- 我的钱包 -->
          <index-manage-item v-on:onclick="goAccount" :src="require('../../../assets/image/myicon/m1.png')"
            :title="$t('MyWallet')">
          </index-manage-item>
          <!-- 我的礼品卡 回收记录 -->
          <index-manage-item v-on:onclick="goGiftBoxList" :src="require('../../../assets/image/myicon/m5.png')"
            :title="$t('GiftCard')">
          </index-manage-item>
          <!-- 联系我们 -->
          <index-manage-item v-on:onclick="getEmail" :src="require('../../../assets/image/myicon/m11.png')"
            :title="$t('Contact us')">
          </index-manage-item>
          <!-- 邀请好友 -->
          <index-manage-item v-on:onclick="getIF" :src="require('../../../assets/image/myicon/m12.png')"
            :title="$t('Invite friends')">
          </index-manage-item>
          <!-- 我的团队 -->
          <index-manage-item v-on:onclick="goMemberInviterManage()"
            :src="require('../../../assets/image/myicon/m3.png')" :title="$t('MyTeam')">
          </index-manage-item>
          <!-- 我的佣金 -->
          <index-manage-item v-on:onclick="goMyCommission()" :src="require('../../../assets/image/myicon/m4.png')"
            :title="$t('MyCommission')">
          </index-manage-item>
        </div>
        <div class="manage_box2">
          <!-- 盲盒记录 -->
          <index-manage-item v-on:onclick="goBox" :src="require('../../../assets/image/myicon/m7.png')"
            :title="$t('BlindBox')">
          </index-manage-item>
          <!-- 我的订单 -->
          <index-manage-item v-on:onclick="goOrder" :src="require('../../../assets/image/myicon/m6.png')"
            :title="$t('MyOrders')">
          </index-manage-item>
          <!-- 我的地址 -->
          <index-manage-item v-on:onclick="goAddress" :src="require('../../../assets/image/myicon/m10.png')"
            :title="$t('Delivery Address')">
          </index-manage-item>
          <!-- 我的账号 -->
          <index-manage-item v-on:onclick="goProfileInfo" :src="require('../../../assets/image/myicon/m2.png')"
            :title="$t('Personal Info')">
          </index-manage-item>
          <!-- 更改密码 -->
          <index-manage-item v-on:onclick="onRetrieve" :src="require('../../../assets/image/myicon/m8.png')"
            :title="$t('Change password')">
          </index-manage-item>
          <!-- 语言选择 -->
          <index-manage-item v-on:onclick="setLang" :src="require('../../../assets/image/myicon/m9.png')"
            :title="$t('Language selection')">
          </index-manage-item>
        </div>
      </div>
    </div>
    <div class="" style="margin: 0 12px">
      <div class="common-btn ds-button-large" @click="logout">
        {{ $t("Log Out") }}
      </div>
    </div>

    <audio src="../../../assets/image/gobuy/44s.mp3" muted style="display: none"></audio>
    <audio src="../../../assets/image/gobuy/15s.mp3" muted style="display: none"></audio>
  </div>
</template>

<script>
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';

import store from '../../../store';
import { uploadImg } from '../../../api/giftcard';
import IndexOrderItem from "./IndexOrderItem";
import IndexManageItem from "./IndexManageItem";
import flexLine from "../../flexLine";
import GuessLike from "../../GuessLike";
import { mapState, mapActions, mapMutations } from "vuex";
import {
  getMemberIndex,
  boxList,
  giftList,
uploadMemberAvatar
} from "../../../api/member";
import { logout} from "../../../api/member";
import { checkInviter } from "../../../api/memberInviter";
import { Toast,Indicator } from "mint-ui";
export default {
  name: "MemberIndex",
  data() {
    return {
      user: {},
      time: "",
      orderCount: {},
      isShow: true,
      box_dot: {}, //盲盒徽标
      gift_dot: {}, //礼品卡徽标
      email_to: "",
    };
  },
  components: {
    flexLine,
    IndexOrderItem,
    IndexManageItem,
    GuessLike,
  },
  mounted() {
    $(this.$refs.slick).slick({
      color: '#EF4618',
      arrows: false, // 显示左右箭头
      autoplay: false, // 自动播放
      // autoplaySpeed: 3000, // 自动播放速度
    });
  },
  created: function () {
    if(!this.isOnline){
      this.$router.push({ name: "HomeMemberLogin" });
    }
    this.utils.preloadImages([
      'https://storage.googleapis.com/gobuy-goods-img/static/box/1.gif',
      'https://storage.googleapis.com/gobuy-goods-img/static/box/2.gif'
    ]);

    this.time = new Date().getTime();
    this.fetchConfig({}).then(
      (response) => { },
      (error) => {
        Toast(error.message);
      }
    );
    if (this.isOnline) {
      boxList().then(
        (response) => {
          if (response && response.result) {
            this.box_dot = response.result;
          }
        },
        (error) => { }
      );
      giftList().then(
        (response) => {
          if (response && response.result) {
            this.gift_dot = response.result;
          }
        },
        (error) => { }
      );

      getMemberIndex().then(
        (response) => {
          if (response && response.result.member_info) {
            this.user = response.result.member_info;
          }
        },
        (error) => { }
      );
    }
  },
  computed: {
    ...mapState({
      isOnline: (state) => state.member.isOnline,
      config: (state) => state.config.config,
    }),

    nickname() {
      let title = "Login/register";
      if (this.isOnline) {
        if (
          this.user &&
          typeof this.user !== "undefined" &&
          JSON.stringify(this.user) !== "{}"
        ) {
          title = this.user.member_nickname;
        }
      }
      return title;
    },
    getScore() {
      let score = "0";
      if (this.isOnline && this.user.member_points) {
        score = this.user.member_points;
      }
      return score;
    },
    // 预存款可用金额 通过store 进行获取
    getAvailablePredeposit() {
      let availablePredeposit = "0.00";
      if (this.isOnline && this.user.available_predeposit) {
        availablePredeposit = this.user.available_predeposit;
      }
      return availablePredeposit;
    },
    getlevelname() {
      let levelname = "";
      if (this.isOnline && this.user.level_name) {
        levelname = this.user.level_name;
      }
      return levelname;
    },
  },
  methods: {
    ...mapActions({
      fetchConfig: "fetchConfig",
    }),
    ...mapMutations({
      memberLogout: "memberLogout",
    }),
    triggerFileSelect() {
      this.$refs.fileInput.click();
    },
    //上传图片
    onMemberAvatar(e) {
      const file = e.target.files[0];
      if (!file) {
        return;
      }
      this.user.member_avatar = URL.createObjectURL(file);
      const formData = new FormData();
      formData.append('image', file);
      formData.append('type', 'home/avatar');
      uploadImg(formData).then(res => {
        this.setMemberAvatar(res.result.file);
      });
    },
    //修改用户头像
    setMemberAvatar(memberavatar){
      uploadMemberAvatar(memberavatar).then(res => {
        Indicator.close();
        Toast(res.message)
      }).catch(function (error) {
        Indicator.close();
        Toast(error.message)
      })
    },
    getEmail() {
      this.$router.push({ name: "MemberContactUs" });
    },
    getIF() {
      this.$router.push({ name: "MemberInviteFriends" });
    },
    signout() {
      this.$router.push({ name: "MemberSignOut" });
    },
    logout() {
      logout(this.user.member_name)
        .then((res) => {
          this.memberLogout();
          this.$router.push({ name: "HomeMemberLogin" });
        })
        .catch(function (error) {
          Toast(error.message);
        });
    },
    showLogin() {
      this.$router.push({ name: "HomeMemberLogin" });
    },
    goScoreList() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberPointList", query: { index: 0 } });
      } else {
        this.showLogin();
      }
    },
    goOrder() {
      if (this.isOnline) {
        this.$router.push({
          name: "MemberOrderList",
        });
      } else {
        this.showLogin();
      }
    },
    goBox() {
      if (this.isOnline) {
        this.$router.push({
          name: "BlindBoxList",
        });
      } else {
        this.showLogin();
      }
    },
    setLang() {
      this.$router.push({ name: "HomeLang" });
    },
    onRetrieve() {
      this.$router.push({ name: "MemberChangePassword" });
    },
    goGiftBoxList() {
      if (this.isOnline) {
        this.$router.push({
          name: "GiftBoxList",
        });
      } else {
        this.showLogin();
      }
    },
    goGiftSave() {
      if (this.isOnline) {
        this.$router.push({
          name: "GiftSave",
        });
      } else {
        this.showLogin();
      }
    },
    goProfileInfo() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberProfileSet" });
      } else {
        this.showLogin();
      }
    },
    goSetting() {
      this.$router.push({ name: "MemberSetting" });
    },
    // 消息通知
    goNews() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberNoticeList" });
      } else {
        this.showLogin();
      }
    },
    // 我的关注
    goFavourite() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberFavorite" });
      } else {
        this.showLogin();
      }
    },
    // 我的地址
    goAddress() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberAddressList" });
      } else {
        this.showLogin();
      }
    },
    // 我的退款
    goReturn() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberOrderreturn" });
      } else {
        this.showLogin();
      }
    },
    goAccount() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberAccount" });
      } else {
        this.showLogin();
      }
    },
    goCommission(e) {
      if (this.isOnline) {
        this.$router.push({ name: "MemberCommission", query: { indexe: e } });
      } else {
        this.showLogin();
      }
    },
    goPredeposit() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberPredepositList" });
      } else {
        this.showLogin();
      }
    },
    // 我的好友列表
    goFriendList() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberFriendList" });
      } else {
        this.showLogin();
      }
    },
    // 商家入驻
    goSellerJoinin() {
      if (this.isOnline) {
        this.$router.push({ name: "SellerJoinin1" });
      } else {
        this.showLogin();
      }
    },
    // 聊天列表
    goMemberChatList() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberChatList" });
      } else {
        this.showLogin();
      }
    },
    // 我的订单评价
    goEvaluateList() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberEvaluateList" });
      } else {
        this.showLogin();
      }
    },
    // 发票管理
    goInvoice() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberInvoiceList" });
      } else {
        this.showLogin();
      }
    },
    // 跳转卖家管理中心
    goSellerInfo() {
      if (this.isOnline) {
        this.$router.push({ name: "SellerIndex" });
      } else {
        this.showLogin();
      }
    },
    // 分销管理中心
    goMemberInviterManage() {
      if (this.isOnline) {
        checkInviter()
          .then((res) => {
            this.$router.push({ name: "MemberInviterManage" });
          })
          .catch(function (error) {
            Toast(error.message);
          });
      } else {
        this.showLogin();
      }
    },
    goMyCommission() {
      if (this.isOnline) {
        checkInviter()
          .then((res) => {
            this.$router.push({ name: "MemberCommission" });
          })
          .catch(function (error) {
            Toast(error.message);
          });
      } else {
        this.showLogin();
      }
    },
    // 意见反馈
    goMemberFeedback() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberFeedback" });
      } else {
        this.showLogin();
      }
    },
    // 虚拟订单
    goVrOrder() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberVrOrderList" });
      } else {
        this.showLogin();
      }
    },
    // 活动记录
    goMarketmanagelog() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberMarketmanagelog" });
      } else {
        this.showLogin();
      }
    },
    // 砍价活动
    gBargain() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberBargainlist" });
      } else {
        this.showLogin();
      }
    },
    // 到货通知
    goArrivalnotice() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberArrivalnotice" });
      } else {
        this.showLogin();
      }
    },
    // 浏览历史
    goBrowse() {
      if (this.isOnline) {
        this.$router.push({ name: "MemberBrowseList" });
      } else {
        this.showLogin();
      }
    },
    gotobuy() {
      setTimeout(() => {
        this.$router.push({ name: "HomeGoBuy" });
      }, 500);
    },
    gotoLuckBuy(){
      this.$router.push({ name: "Hunt" });
    },
    gotoIm() {
      setTimeout(() => {
        window.location.href = '/im/?token='+store.state.member.token
      }, 500);
    },
  },
};
</script>
<style>
.banner-container {
  cursor: pointer;
  width: 90%;
  height: 95px;
  margin: 15px auto 5px;
}
.slick-slider img {
  width: 100%;
  height: auto;
}
.slick-prev:before, .slick-next:before {
  color:#ef4517 !important;
}
</style>
<style scoped lang="scss">
.addtime {
  font-size: 15px;
  color: #7c7c7c;
}

.ds-button-large {
  background: linear-gradient(90deg, #e8090c 0%, #f3611e 100%);
  margin-bottom: 60px;
}

.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  z-index: -1;
  text-align: center;

  .top-wrapper {
    margin: 50px 12px 0px 12px;
    position: relative;
    background-image: url("../../../assets/image/teambox.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .top-info-wrapper {
      display: flex;
      justify-content: start;
      align-items: center;
    }
  }

  .nav-item {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 1.2rem;

    .icon {
      position: absolute;
      right: 1.4rem;
      top: -8px;
      font-size: $h6;
      line-height: 0.7rem;
      width: 0.9rem;
      height: 0.7rem;
      background: #ef3338;
      border-radius: 1rem;
      text-align: center;
      color: #ffffff;
    }

    span {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 50%;
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
    }
  }

  #left-nav-item {
    left: 0.7rem;
  }

  #right-nav-item {
    right: 0.7rem;
  }

  .nav-icon {
    margin-right: 15px;
    width: 1.2rem;
    text-align: center;
    color: #fff;
  }

  .avatar-wrapper {
    position: relative;
    margin: 0px 20px;
    width: 3.5rem;
    height: 3.5rem;
    top: 20px;
    left: 25px;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    border-radius: 50%;
    border: 1px solid #f04e196b;
    overflow: hidden;
    line-height: 3.5rem;
    .avatar {
      width: 100%
    }
    span{
      display: block;
      width: 100%;
      height: 20px;
      position: absolute;
      bottom: 0;
      background: #ffefeba8;
      line-height: 20px;
    }
  }

  .nickname {
    margin-top: 0.75rem;
    font-size: 18px;
    font-weight: 600;
    color: rgb(0, 0, 0);
    text-align: left;
    margin-left: 0;
    margin-right: 0;
  }

  .uid {
    margin-top: 0.15rem;
    font-size: 15px;
    color: #7c7c7c;
  }

  .level_name_wrapper {
    font-size: 0.6rem;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin-left: 0;
    margin-right: 0;
    border-radius: 0.2rem;

    display: inline-block;
    padding: 0.1rem 0.2rem;
  }

  .level_name {
    display: flex;
    align-items: center;
  }

  .levelname-icon {
    width: 1rem;
    height: 0.6rem;
    padding-right: 0.2rem;
  }

  .info-wrapper {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 0px;
    border-radius: 0.4rem;
    z-index: 2;
  }

  .info-item {
    flex: 1;
    text-align: center;
    font-size: $h2;
    color: #7f7f7f;
    position: relative;

    &:first-child::after {
      position: absolute;
      top: 0.5rem;
      bottom: 0.5rem;
      right: 0;
      border-right: 1px dashed #eee;
    }

    .item {
      color: rgba(51, 51, 51, 1);
      font-size: 13px;
      padding-top: 0.2rem;
    }

    .price {
      font-size: $h2;
      color: #fb2933;
      font-weight: 600;
    }
  }

  .order-header {
    background-color: #fff;
    padding: 0 $pageSpace;
    margin-top: $modelSpace;
  }

  .item-title {
    font-size: $subFontSize;
    color: $formInputColor;
    font-weight: 700;
  }

  .order-subtitle {
    font-size: $fontSize;
    color: $descTextColor;
  }

  .order {
    margin: 10px 12px;
    border-radius: 10px;

    .order-header {
      margin: 0 0 1rem 0;
      padding: 0;
      min-height: auto;
    }
  }

  .order-wrapper {
    padding: 10px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    background-color: #fff;
  }

  .order-item {
    flex: 1;
  }

  .bottom-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    margin-top: $modelSpace;
    margin-bottom: $modelSpace;
    background: #fff;
    padding: 0 $pageSpace;

    .item-icon {
      width: 1.2rem;
      height: 1.2rem;
      margin-right: 0.4rem;
    }
  }

  .manage-wrapper {
    .manage_box1 {
      padding: 1rem 0px 0.5rem 0px;
      background-image: url("../../../assets/image/mybgc1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .manage_box2 {
      padding: 1rem 0px 0.5rem 0px;
      background-image: url("../../../assets/image/mybgc2.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
}

.banner {
  margin: 0rem 12px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>